import React from "react";
import { Card, Badge, Avatar } from "antd";
import {
  UserOutlined,
  TeamOutlined,
  BookOutlined,
  CrownOutlined,
} from "@ant-design/icons";
import "./ClassGrid.css";

const ClassGrid = ({ classes, onClassClick, profesori }) => {
  const getGradeType = (anClasa) => {
    const grade = anClasa?.toLowerCase();

    // Check if it's a postliceala class
    if (
      anClasa?.includes("Anul") &&
      process.env.REACT_APP_NAME === "Liceul Teoretic Sanitar Bistrita"
    ) {
      return "postliceala";
    }

    if (
      grade === "pregătitoare" ||
      grade === "i" ||
      grade === "ii" ||
      grade === "iii" ||
      grade === "iv"
    ) {
      return "primary";
    } else if (
      grade === "v" ||
      grade === "vi" ||
      grade === "vii" ||
      grade === "viii"
    ) {
      return "middle";
    } else if (
      grade === "ix" ||
      grade === "x" ||
      grade === "xi" ||
      grade === "xii" ||
      grade === "xiii"
    ) {
      return "high";
    } else {
      return "high"; // Default to high for unknown grades
    }
  };

  const getGradeColor = (gradeType) => {
    switch (gradeType) {
      case "primary":
        return "#52c41a";
      case "middle":
        return "#1890ff";
      case "high":
        return "#003d82";
      case "postliceala":
        return "#722ed1";
      default:
        return "#1890ff";
    }
  };

  const getGradeLabel = (gradeType) => {
    switch (gradeType) {
      case "primary":
        return "Primar";
      case "middle":
        return "Gimnaziu";
      case "high":
        return "Liceu";
      case "postliceala":
        return "Postliceala";
      default:
        return "";
    }
  };

  const formatClassName = (clasa) => {
    if (clasa?.anClasa === "Pregătitoare" || clasa?.anClasa === "I") {
      return `${clasa.anClasa} ${clasa.identificator}`;
    }

    // For classes with "Anul" when REACT_APP_NAME is "Liceul Teoretic Sanitar Bistrita", show "Anul" directly
    if (
      clasa?.anClasa?.includes("Anul") &&
      process.env.REACT_APP_NAME === "Liceul Teoretic Sanitar Bistrita"
    ) {
      return `${clasa.anClasa} ${clasa.identificator}`;
    }

    return `a ${clasa.anClasa}-a ${clasa.identificator}`;
  };

  const getDiriginteName = (clasa) => {
    const diriginte = profesori?.find((pf) => pf.id === clasa.diriginte);
    const diriginteStep = profesori?.find(
      (pf) => pf.id === clasa.diriginte_step
    );

    let result = diriginte
      ? `${diriginte.numeDeFamilie} ${diriginte.prenume}`
      : "Fără diriginte";
    if (diriginteStep) {
      result += `, ${diriginteStep.numeDeFamilie} ${diriginteStep.prenume}`;
    }
    return result;
  };

  return (
    <div className="class-grid">
      {classes?.map((clasa, index) => {
        const gradeType = getGradeType(clasa?.anClasa);
        const gradeColor = getGradeColor(gradeType);
        const gradeLabel = getGradeLabel(gradeType);

        return (
          <div
            key={clasa.id || index}
            className={`class-card class-card-${gradeType}`}
            onClick={() => onClassClick(clasa)}
          >
            <div
              className="class-card-header"
              style={{ borderTopColor: gradeColor }}
            >
              <div className="class-card-badge">
                <Badge
                  count={gradeLabel}
                  style={{
                    backgroundColor: gradeColor,
                    fontSize: "10px",
                    height: "20px",
                    lineHeight: "20px",
                    borderRadius: "10px",
                    minWidth: "45px",
                  }}
                />
              </div>
              <div className="class-card-icon">
                <Avatar
                  size={40}
                  style={{
                    backgroundColor: gradeColor,
                    fontSize: "18px",
                  }}
                  icon={<BookOutlined />}
                />
              </div>
            </div>

            <div className="class-card-body">
              <h3 className="class-card-title">{formatClassName(clasa)}</h3>

              <div className="class-card-info">
                <div className="info-item">
                  <UserOutlined className="info-icon" />
                  <span className="info-text">{getDiriginteName(clasa)}</span>
                </div>
              </div>
            </div>

            <div className="class-card-footer">
              <div className="footer-stats">
                <div className="stat-item">
                  <TeamOutlined />
                  <span>Elevi</span>
                </div>
                <div className="stat-arrow">→</div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ClassGrid;
